import type { PointArray } from '../types/contour-definition-array-type';

import { getPolygonDifference } from './getPolygonDifference';
import { getPolygonIntersection } from './getPolygonIntersection';

/**
 * Subtracts every sibling polygon that overlaps `child` from `child`, so that
 * sibling contours never cross each other.
 *
 * Returns the (largest) remaining region. If no sibling overlaps `child`, the
 * original `child` reference is returned unchanged.
 *
 * All polygons must be in the same coordinate space.
 */
export function subtractSiblingOverlaps(
  child: PointArray,
  siblings: PointArray[],
): PointArray {
  let result = child;

  for (const sibling of siblings) {
    if (sibling.length < 4 || result.length < 4) continue;

    const overlap = getPolygonIntersection(result, sibling);
    if (overlap.length < 4) continue;

    const diff = getPolygonDifference(result, sibling);
    if (diff.length >= 4) result = diff;
  }

  return result;
}
